export default __webpack_public_path__ + "static/media/001-facebook.07d3e099.svg";